<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />

	<app-panel-summary label="Status" :tag="$constants.volunteers.assignment.statusName[item.status]" :status="$constants.volunteers.assignment.statusTheme[item.status]" :theme="$constants.volunteers.assignment.statusTheme[item.status]" />

	<app-panel-summary label="Reference" :value="item.reference" />

	<app-panel-summary label="Volunteer" :value="item.badge.name" />

	<app-panel-summary label="Role" :value="item.role.name" />

	<app-panel-summary label="Slot" :value="item.slot.name" />
	
</app-panel-content>

</template>

<script>

export default {

    props: ['item', 'references']

}

</script>

<style scoped>

</style>
